import ClearCacheView from './ClearCacheView';

export default ClearCacheView;